import { Modal } from 'antd'
import { FC, PropsWithChildren, ReactNode, useState } from 'react'

interface FormModalProps {
    width?: number
    title?: string
    renderOpener: (onOpen: () => void) => ReactNode
    renderContent?: (onClose: () => void) => ReactNode
}

const FormModal: FC<PropsWithChildren<FormModalProps>> = ({
    width = 1200,
    title,
    renderOpener,
    renderContent = () => null,
    children,
}) => {
    const [open, setOpen] = useState<boolean>(false)

    return (
        <>
            {renderOpener(() => setOpen(true))}
            <Modal
                title={title}
                width={width}
                footer={null}
                open={open}
                destroyOnClose
                onCancel={() => setOpen(false)}
            >
                {children || renderContent(() => setOpen(false))}
            </Modal>
        </>
    )
}

export default FormModal
